import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ticketPaymentService from "@/services/api/ticketPayments";
import type { GetTicketPaymentsParams, TicketPayment } from "@/services/api/ticketPayments";

export interface TicketPaymentState {
  ticketPayments: TicketPayment[];
  totalTicketPayments: number;
  ticketRevenue: number;
  totalGstCollected: number;
  failedPayments: number;
  isFetching: boolean;
  error: string | null;
}

const initialState: TicketPaymentState = {
  ticketPayments: [],
  totalTicketPayments: 0,
  ticketRevenue: 0,
  totalGstCollected: 0,
  failedPayments: 0,
  isFetching: false,
  error: null,
};

export const getTicketPayments = createAsyncThunk(
  "ticketPayment/getTicketPayments",
  async (params: GetTicketPaymentsParams) => ticketPaymentService.getAllTicketPayments(params),
);

const ticketPaymentSlice = createSlice({
  name: "ticketPayment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTicketPayments.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(getTicketPayments.fulfilled, (state, action) => {
        state.isFetching = false;
        state.ticketPayments = action.payload?.data?.results ?? [];
        state.totalTicketPayments = action.payload?.data?.totalRecord ?? state.ticketPayments.length;
        state.ticketRevenue = action.payload?.data?.ticketRevenue ?? 0;
        state.totalGstCollected = action.payload?.data?.totalGstCollected ?? 0;
        state.failedPayments = action.payload?.data?.failedPayments ?? 0;
      })
      .addCase(getTicketPayments.rejected, (state, action) => {
        state.isFetching = false;
        state.ticketPayments = [];
        state.error = action.error.message ?? "Failed to load ticket payments";
      });
  },
});

export default ticketPaymentSlice.reducer;
